import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as actions from './reference-scheme.actions';
import { ReferenceScheme, ReferenceSchemeModuleState } from '../models/reference-scheme.model';

function selectIdNumber(c: ReferenceScheme): number {
  return c.id;
}

export const adapter: EntityAdapter<ReferenceScheme> = createEntityAdapter<ReferenceScheme>({
  selectId: selectIdNumber,
});

export const initialState = <ReferenceSchemeModuleState>{
  referenceSchemes: adapter.getInitialState([]),
  isLoaded: false,
};
const referenceSchemeReducer = createReducer(
  initialState,
  on(actions.clearReferenceSchemeState, (state) => ({
    ...state,
    isLoaded: false,
    feedAdvices: adapter.removeAll(state.referenceSchemes),
  })),
  on(actions.loadReferenceSchemesSuccess, (state, { referenceSchemes }) => ({
    ...state,
    isLoaded: true,
    referenceSchemes: adapter.setAll(referenceSchemes, state.referenceSchemes),
  })),
  on(actions.deleteReferenceSchemeSuccess, (state, { referenceSchemeId }) => ({
    ...state,
    referenceSchemes: adapter.removeOne(referenceSchemeId, state.referenceSchemes),
  })),
  on(actions.loadSelectedCountrySuccess, (state, { id }) => ({
    ...state,
    selectedCountry: id,
  })),
  on(actions.setSelectedCountrySuccess, (state, { id, referenceSchemes }) => ({
    ...state,
    selectedCountry: id,
    referenceSchemes: adapter.setAll(referenceSchemes, state.referenceSchemes),
  })),
  on(actions.loadProductsByCountrySuccess, (state, { products }) => ({
    ...state,
    products,
  })),
);

export function reducer(state: ReferenceSchemeModuleState | undefined, action: Action) {
  return referenceSchemeReducer(state, action);
}
